/** Normalises a stored note value for display in RichTextContent.
 *  Plain-text values (no HTML tags) are HTML-escaped then have newlines converted to <br>.
 *  Tag detection requires a letter after < to avoid false positives on strings like "<3". */
export function normaliseForDisplay(value: string): string {
  if (/<\/?[a-zA-Z][^>]*>/.test(value)) return value
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\n/g, '<br>')
}
